export const cuposFormUrl = 'https://edge.akdemia.com/enrollments/b4b6650e3c87e700'
